export function getPeriodTypeToString(periodType) {
  let periodStr = '';
  if (periodType === 'D') {
    periodStr = '일간';
  } else if (periodType === 'W') {
    periodStr = '주간';
  } else if (periodType === 'M') {
    periodStr = '월간';
  } else if (periodType === 'Q') {
    periodStr = '분기';
  } else if (periodType === 'H') {
    periodStr = '반기';
  } else if (periodType === 'Y') {
    periodStr = '연간';
  } else if (periodType === 'C') {
    periodStr = '사용자 정의';
  }
  return periodStr;
}

export default getPeriodTypeToString;



// WEBPACK FOOTER //
// ./src/utils/report.js